'use client';

import { redirect } from 'next/navigation';

export default function FaqRedirect() {
  // Get the user's language from localStorage (default to 'ar')
  const language = localStorage.getItem('i18nextLng') || 'ar';

  // Redirect /faqs → language-specific FAQs page
  redirect(`/${language}/faqs`);
}
